<!-- <div [hidden]="!show" class="loader-wrapper">
    <img src="/assets/images/preloader.gif">
</div> -->
<div *ngIf="show" class="loader-wrapper">
    <mat-spinner style="margin:0 auto;" strokeWidth="5" diameter="70"></mat-spinner>
</div>
